var _path, _ellipse, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1048 3.92965C8.7112 3.92965 7.5815 2.79995 7.5815 1.40639C7.5815 0.885705 7.73921 0.401852 8.00948 0H2.94186C1.31712 0 0 1.31712 0 2.94186V8.05814C0 9.68288 1.31712 11 2.94186 11H8.05814C9.68288 11 11 9.68288 11 8.05814V3.76622C10.7218 3.87183 10.42 3.92965 10.1048 3.92965ZM9.66942 0.480095C10.2382 0.85315 10.6699 1.41804 10.8726 2.08279C10.6851 2.29548 10.4106 2.42965 10.1048 2.42965C9.53963 2.42965 9.0815 1.97152 9.0815 1.40639C9.0815 0.996944 9.32199 0.643663 9.66942 0.480095ZM2.44805 7.47166C2.13632 7.1989 2.10473 6.72508 2.3775 6.41335L4.16819 4.36684C4.43632 4.06041 4.89996 4.02388 5.21276 4.28455L6.1852 5.09491L7.49377 3.59939C7.76654 3.28767 8.24036 3.25608 8.55208 3.52884C8.86381 3.8016 8.8954 4.27542 8.62264 4.58715L6.83194 6.63366C6.56382 6.94009 6.10017 6.97662 5.78737 6.71595L4.81494 5.90559L3.50636 7.4011C3.2336 7.71283 2.75978 7.74442 2.44805 7.47166Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.02326,
    cy: 1.02326,
    rx: 1.02326,
    ry: 1.02326,
    transform: "matrix(-1 0 0 1 11.1279 0.382812)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9L17.8306 6.28095C18.2158 5.83156 18.2158 5.16844 17.8306 4.71905L15.5 2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.af5e68eb24e984e4e957a68f7bfc656e.svg";
export { ForwardRef as ReactComponent };